import { SymbolDefinition } from '../SymbolComponent';

const NAME = 'hexagon';
export interface HexagonSymbol extends SymbolDefinition {
  name: typeof NAME;
}

export const hexagonSymbol: HexagonSymbol = {
  name: NAME,
  lockedAspectRatio: false,
  startWithFixedAspectRatio: false,
  hasStrokeSettings: true,
};
